const SideTypeList = ['privacy', 'wallet', 'userProfile', 'updatePassword']
const KeycloakSideTypeList = ['shippingAddress', 'updateAccount', 'securitySetting']

export default SideTypeList
export { KeycloakSideTypeList }
